var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('v-footer',{attrs:{"color":_vm.$vuetify.theme.themes[_vm.theme].background}},[_c('div',{staticClass:"dividing-line"}),_c('div',{staticClass:"disclaimer my-9"},[_vm._v(" "+_vm._s(this.$i18n.t("footer.disclaimer"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }